import { SpaceConfigState } from "../reducer";

export default function selectAllSlugs(state: SpaceConfigState): Set<string> {
  return new Set(
    Array.from(state.spaces.values())
      .flatMap(s => Array.from(s.components.keys()))
      .concat(Array.from(state.removedSlugs.values()).flatMap(r => Array.from(r)))
  );
}
